import React from "react";
import "../Style/Work.scss";

const Work = ({ item }) => {
  return (
    <div className="col-md-6">
      <div className="work_info">
        <img src={item.image} alt="img" />
        <div className="content">
          <h3 className="work-h3">{item.title}</h3>
          <p className="work-p">{item.des}</p>
        </div>
      </div>
    </div>
  );
};

export default Work;
